import { useNavigate } from "react-router-dom";
import { imgUrl } from "@/lib/api";
import { useData } from "@/context/DataContext";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function PromoCard({ business, index = 0, full = false }) {
  const navigate = useNavigate();
  const { getCategory } = useData();
  const cat = getCategory(business.category);
  const d = business.discount || {};

  return (
    <motion.button
      data-testid={`promo-card-${business.id}`}
      onClick={() => navigate(`/negocio/${business.id}`)}
      initial={{ opacity: 0, scale: 0.96 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: Math.min(index * 0.06, 0.4), duration: 0.4 }}
      whileTap={{ scale: 0.96 }}
      className={`grain relative flex h-52 shrink-0 flex-col justify-between overflow-hidden rounded-3xl p-5 text-left text-white shadow-xl ${
        full ? "w-full" : "w-64"
      }`}
      style={{ background: "linear-gradient(135deg, #E54D2E 0%, #FF8C42 100%)" }}
    >
      {business.hero_image_url && (
        <img
          src={imgUrl(business.hero_image_url)}
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-25"
        />
      )}
      <div className="relative z-10 flex items-start justify-between">
        <span className="rounded-full bg-white/20 px-3 py-1 text-[11px] font-bold uppercase tracking-wide backdrop-blur">
          {cat.label}
        </span>
        <ArrowUpRight size={22} strokeWidth={2.5} />
      </div>
      <div className="relative z-10">
        {d.badge && (
          <p className="font-display text-4xl font-black leading-none tracking-tighter drop-shadow">
            {d.badge}
          </p>
        )}
        <p className="mt-2 text-sm font-bold leading-snug drop-shadow">{d.title}</p>
        <p className="mt-1 text-[13px] font-semibold opacity-90">{business.name}</p>
      </div>
    </motion.button>
  );
}
